import React from 'react';
import { useAuth } from '@readsavor/auth';
import { Button } from '@readsavor/ui';
import { supabase } from '@readsavor/supabase-client';

/**
 * 全局认证状态错误处理器
 *
 * 当 useAuth hook 报告全局性错误时，此组件会渲染一个全屏的错误界面，
 * 阻止用户与可能处于不一致状态的应用进行交互。
 */
export const GlobalAuthErrorHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isError, error } = useAuth();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  if (isError) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center pb-[20vh] text-center">
        <div className="w-full max-w-md rounded-lg bg-white pt-3 px-8 pb-3 shadow-md">
          <h1
            className="text-2xl font-bold text-interactive-coral-red"
            style={{ margin: '1rem 0' }}
          >
            Application Error
          </h1>
          <p className="mb-6 text-gray-600">
            We couldn&apos;t verify your session, which might be due to a network issue or our being
            temporarily unavailable.
          </p>
          {error && (
            <p className="mb-6 rounded-md bg-gray-100 p-2 text-left text-sm text-gray-500">
              <strong>Error Details:</strong> {error.message}
            </p>
          )}
          <div className="space-y-3">
            <Button onClick={() => window.location.reload()} size="large" className="w-full">
              Refresh
            </Button>
            <Button onClick={handleLogout} size="large" className="w-full" variant="secondary">
              Log Out
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
